import { Campaign, CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { transformCampaignApiToCommonFormFields } from './transformCampaignApiToCommonFormFields';
import { API_UNLIMITED_MAX_DELIVERY_DISTANCE } from '../../components/budget-section/constants';
import { BasketDiscountFormValues } from '../../types';
import { getBasketDiscountType } from '../getBasketDiscountType';
import { getBasketDiscountValue } from '../getBasketDiscountValue';

export const transformCampaignApiToBasketDiscountForm = (
  campaign: Campaign,
  timezone: string,
): BasketDiscountFormValues => {
  const discountType = getBasketDiscountType(campaign.basket_discount);

  return {
    ...transformCampaignApiToCommonFormFields(campaign, timezone),
    campaignType: CampaignType.BASKET_DISCOUNT,
    discountValue: getBasketDiscountValue(discountType, {
      percentage: campaign.basket_discount.percentage,
      amount: campaign.basket_discount.amount,
      upperLimit: campaign.basket_discount.upper_limit,
    }),
    discountType,
    agreementTermsAndConditions: true,
    maxDeliveryDistance: API_UNLIMITED_MAX_DELIVERY_DISTANCE,
  };
};
